import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

export const replaceFlightNumberPrefix = (str: string) => {
  return str.replace(/f[12]_/g, '');
}

const useGetAttributeTranslation = () => {
  const { sideFilters: side_filters_t, general: t } = useSelector(
    (state: RootState) => state.config.translations
  );

  const attributeTranslation = (attribute: string) => {
    const adjustedAttribute = replaceFlightNumberPrefix(attribute);
    return side_filters_t?.[adjustedAttribute] ?? t?.[adjustedAttribute] ?? adjustedAttribute;
  };

  return attributeTranslation;
};

export default useGetAttributeTranslation;
